module.exports = __webpack_public_path__ + "fonts/6fda99f75d8472be30a61aeb1a081d7b.svg";